import * as store from '@daas-consulting/core-frontend-store';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { context, feature } from '../remitos.const';

const getPrintDataActions = store.getActionsNames({
  context,
  feature,
  section: 'print',
  action: 'Get print data',
});

const printActions = store.getActionsNames({
  context,
  feature,
  section: 'print',
  action: 'Print',
});

export class GetPrintData {
  static readonly type = `${getPrintDataActions.action}`;
  constructor(readonly payload: string) {}
}

export class GetPrintDataRequest {
  static readonly type = `${getPrintDataActions.request}`;
}

export class GetPrintDataSuccessful {
  static readonly type = `${getPrintDataActions.successful}`;
  constructor(readonly payload: models.print.PrintDataView) {}
}

export class GetPrintDataFailure {
  static readonly type = `${getPrintDataActions.failure}`;
  constructor(readonly payload: Error) {}
}

export interface PrintPayload {
  remitoId: string;
}

export class Print {
  static readonly type = `${printActions.action}`;
  constructor(readonly payload: PrintPayload) {}
}

export class PrintRequest {
  static readonly type = `${printActions.request}`;
}

export class PrintSuccessful {
  static readonly type = `${printActions.successful}`;
}

export class PrintFailure {
  static readonly type = `${printActions.failure}`;
  constructor(readonly payload: Error) {}
}
